<template>
    <div class="quick-guidance-wrapper">
        <div class="title flex-sb">
            <div class="flex-all-center">
                <eui-icon icon="eicon-peizhiyindao" color="#333" font-size="18px"/>
                <span class="text">快速上手，玩转易专采</span>
            </div>
            <div class="hide-box" @click="toHide">隐藏</div>
        </div>
        <div class="quick-guidance-content">
            <div v-for="(item,index) in quickGuidanceData" :key="index" class="quick-guidance-box"  :class="{'margin-r10': index !== 3}">
                  <div class="guidance-left flex-all-center">
                      <eui-icon v-if="item.ifConfig === 1" icon="eicon-right-normal" color="#50AA43" font-size="24px" />
                      <eui-icon v-if="item.ifConfig === 0" :icon="item.icon" color="#2587FF" font-size="24px" />
                  </div>
                  <div class="guidance-right">
                      <div class="guidance-right-top flex-sb">
                          <div class="guidance-title">{{item.title}}</div>
                          <div  class="guidance-go" @click="toGo(item.url,item.isOther,item.ifConfig)">
                              <span v-if="item.ifConfig === 1" >前往</span>
                              <span v-if="item.ifConfig === 0">{{item.tip}}</span>
                              <eui-icon icon="eicon-arrow-right" color="#0064c8" font-size="12px" style="margin-left: 4px"/>
                           </div>
                      </div>
                      <div class="guidance-right-bottom">
                          {{item.content}}
                      </div>
                  </div>
            </div>
        </div>

    </div>
</template>

<script>
  import api from '@/modules/projectA/api/user';
  import { epecMallUrl } from '../../../../api/config';
  export default {
    name: "quickGuidance",
    data() {
      return {
        //ifConfig 设置 999 处理 闪现
        quickGuidanceData: [
          {title: '采购商城配置', content: '选择商城类目及供应商',url:'/exclusivePurchase', icon: 'eicon-scpz-unselected', ifConfig: 999, tip:'立即配置'},
          {title: '完善组织机构', content: '配置部门',url:'/institutionManage', icon: 'eicon-company-unselected', ifConfig: 999, tip:'立即完善'},
          {title: '员工管理', content: '创建子账号，分配角色权限',url:'/userManage', icon: 'eicon-user-unselected', ifConfig: 999, tip:'立即创建'},
          {title: '更多进阶操作', content: '快速了解全局功能', url:epecMallUrl + '/eCourse',isOther:'true',icon: 'eicon-gengduojinjiecaozuo', ifConfig: 999, tip:'立即查看'},
        ],
      }
    },
    methods:{
      toGo(url,isOther,ifConfig){
        if(isOther){
          window.open(url);
          //判断如果是 初次点击 调接口更新 查看状态
          console.log(ifConfig,ifConfig === 0,'ifConfig')
          if(ifConfig === 0){
            this.memberActionSave();
          }
        }else{
          this.$router.push(url);
        }
      },
      //判断如果是 初次点击 调接口更新 查看状态
      async memberActionSave(){
        const res = await api.memberActionSave({action: "yzcAdvanced", value:"click"});
        if(res.success){
          this.mainInfo();
        }
      },
      toHide(){
        this.$emit('changeShow');
      },
      async mainInfo(){
        const res = await api.mainInfo();
        if (res.success) {
            this.quickGuidanceData[0].ifConfig = Number(res.data.hasPurchaseAreaBanner && res.data.hasPurchaseAreaLogo);
            this.quickGuidanceData[1].ifConfig = Number(res.data.hasOrg);
            this.quickGuidanceData[2].ifConfig = Number(res.data.hasMember);
            this.quickGuidanceData[3].ifConfig = Number(res.data.hasClickAdvanced);
        }
      },
    },
    mounted() {
      this.mainInfo();
    }
  }
</script>

<style scoped lang="scss">
    .quick-guidance-wrapper {
        margin-top: 20px;
        border: 1px solid #D9D9D9;
        .hide-box{
            font-size: 12px;
            color: #0064c8;
            cursor: pointer
        }

        .title {
            font-size: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f5f5f5;
            height: 44px;
            padding: 0 20px;
            color: #333;

            .text {
                margin-left: 10px;
            }

            .more {
                color: #333;
                display: flex;
                align-items: center;
                cursor: pointer;
                font-weight: normal;

                &:hover {
                    color: #0064c8;
                }
            }

            .sp-text {
                color: #999;
                font-size: 12px;
                font-weight: 350;
                margin-left: 10px;
            }
        }

        .quick-guidance-content {
            width: 100%;
            height: 116px;
            background-color: #fff;
            padding: 20px;
            display: flex;
            .quick-guidance-box {
                padding: 16px 10px;
                flex: 1;
                background-color: #F8F8F8;
                display: flex;
                cursor: pointer;
                .guidance-left{
                    width: 44px;
                    height: 100%;
                }
                .guidance-right{
                    width: 100%;
                    margin-left: 10px;
                    .guidance-right-top{
                        .guidance-title{
                            color: #666;
                            font-size: 14px;
                            font-weight: 500;
                        }
                        .guidance-go{
                            color: #0064C8;
                            font-size: 12px;
                        }

                    }
                    .guidance-right-bottom{
                        color: #999;
                        font-size: 12px;
                        font-weight: 350;
                        margin-top: 6px;
                    }

                }
               &:hover{
                   background-color: #F4F7FF;
                   .guidance-right .guidance-right-top .guidance-title{
                       color:  #0064C8;
                   }
               }

            }
        }
    }
</style>